module.exports = __webpack_public_path__ + "static/media/076.b4cb8e62.jpg";